module.exports = __webpack_public_path__ + "media/entities/1121-27feb9ac.png";